export default "__VITE_ASSET__BNtvBPcu__"